import React from 'react';
import ReactDOM from 'react-dom/client';
import SykesApp from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SykesApp />
  </React.StrictMode>
);
